@if (inputs.length > 0) {
	<h2>{{ 'query.add-input' | translate }}</h2>
	<list-view [selectable]="false">
		<header [sortColumn]="false">{{ 'query.column.query-name' | translate }}</header>
		<header [sortColumn]="false">{{ 'query.column.property' | translate }}</header>
		<header [sortColumn]="false">{{ 'query.column.operator' | translate }}</header>
		<header [sortColumn]="false">{{ 'query.column.value' | translate }}</header>
		<header [sortColumn]="false"></header>
		<row *listData="let input from inputs">
			<column>{{ input.query.name }}</column>
			<column>{{ getPropertyLabel(input.query, input.filter) }}</column>
			<column>{{ 'query.operator.' + operatorType[input.filter.operator] | translate }}</column>
			<column>
				<query-input [propertyName]="input.filter.property?.name"
							 [queryProperties]="input.query.queryProperties"
							 [options]="input.filter.property?.options ?? {}"
							 [value]="input.filter.inputValue"
							 (valueChange)="setInputValue(input.query, input.filter, $event)" />
			</column>
			<column>
				@if (canBeEmpty(input.filter)) {
					<custom-input [inputType]="inputTypeEnum.Switch" [label]="'query.input-empty' | translate" [(value)]="input.filter.allowEmpty" />
				}
			</column>
		</row>
	</list-view>
}
